var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dropdownPaymentWht"}},[_c('DropdownComponent',{attrs:{"label":"อัตราที่หัก","trackBy":"type","options":_vm.options,"selected":_vm.selectedWht,"search":false,"disabled":_vm.disabled},on:{"update:selected":function($event){_vm.selectedWht=$event},"change":_vm.SelectWht},scopedSlots:_vm._u([{key:"selected",fn:function(ref){
var props = ref.props;
return [_c('p',[_vm._v(_vm._s(props.name))])]}},{key:"options",fn:function(ref){
var props = ref.props;
return [_c('p',[_vm._v(_vm._s(props.name))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }